import { FaHeart, FaRegUser, FaSearch, FaShoppingBag } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import type { NavItem } from '../../types';
import { useCart } from './CartContext';

interface HeaderProps {
  navItems: NavItem[];
  searchValue?: string;
  onSearchChange?: (value: string) => void;
}

const Header = ({ navItems, searchValue = '', onSearchChange }: HeaderProps) => {
  const { itemCount, subtotal } = useCart();
  const subtotalLabel = new Intl.NumberFormat('es-CR', {
    style: 'currency',
    currency: 'CRC',
    maximumFractionDigits: 0,
  }).format(subtotal);

  return (
    <header className="site-header">
      <div className="container header-row">
        <div className="brand-block">
          <Link to="/" className="brand-link">
            <img src="/EMDKLogo.png" alt="El Mercadito de Kila" className="brand-logo" />
            <span className="brand-copy">
              <span className="brand-kicker">Boutique online</span>
              <span className="brand-name">El Mercadito de Kila</span>
            </span>
          </Link>
        </div>

        <div className="search-shell" aria-label="Busqueda de productos">
          <FaSearch />
          <input
            type="search"
            placeholder="Buscar vestidos, blusas, accesorios..."
            value={searchValue}
            onChange={(event) => onSearchChange?.(event.target.value)}
          />
        </div>

        <div className="header-actions">
          <button type="button" aria-label="Favoritos">
            <FaHeart />
          </button>
          <button type="button" aria-label="Mi cuenta">
            <FaRegUser />
          </button>
          <Link to="/carrito" aria-label={`Carrito con ${itemCount} productos`} className="cart-button">
            <FaShoppingBag />
            <span>{itemCount ? subtotalLabel : 'CRC 0'}</span>
          </Link>
        </div>
      </div>

      <div className="container nav-row">
        <nav className="nav-links">
          {navItems.map((item) => (
            <a key={item.id} href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
